import React from 'react';
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Stack,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Box,
} from '@mui/material';
import {
  PersonOutline as PersonIcon,
  LockOutlined as LockIcon,
  // eslint-disable-next-line no-unused-vars
  PeopleOutline as UsersIcon,
  // eslint-disable-next-line no-unused-vars
  QueueOutlined as QueueIcon,
  // eslint-disable-next-line no-unused-vars
  BuildOutlined as ServicesIcon,
  // eslint-disable-next-line no-unused-vars
  Inventory2Outlined as ProductsIcon,
  // eslint-disable-next-line no-unused-vars
  SmartToyOutlined as AIIcon,
  // eslint-disable-next-line no-unused-vars
  StorefrontOutlined as BusinessIcon,
  Logout as LogoutIcon,
  ChevronRight as ChevronRightIcon,
  NotificationsNone as NotificationsIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ProfileSummaryCard from '../../components/ProfileSummaryCard';
import MainLayout from '../../components/MainLayout';

const Settings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout, collaborator } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userName = collaborator?.name || 'Usuário';

  const menuItems = [
    {
      id: 'profile',
      label: t('settings.profile'),
      hint: t('settings.profileHint'),
      icon: PersonIcon,
      disabled: false,
      path: '/settings/profile',
    },
    {
      id: 'change-password',
      label: t('settings.changePassword'),
      hint: t('settings.changePasswordHint'),
      icon: LockIcon,
      disabled: false,
      path: '/settings/change-password',
    },
    {
      id: 'notifications',
      label: t('settings.notifications'),
      hint: t('settings.notificationsHint'),
      icon: NotificationsIcon,
      disabled: false,
      path: '/settings/notifications',
    },
    /* TODO v1: menu items — hidden for v0
    { id: 'users', label: t('settings.users'), icon: UsersIcon, disabled: true },
    { id: 'queue', label: t('settings.queueManagement'), icon: QueueIcon, disabled: true },
    { id: 'services', label: t('settings.services'), icon: ServicesIcon, disabled: true },
    { id: 'products', label: t('settings.products'), icon: ProductsIcon, disabled: true },
    { id: 'ai', label: t('settings.aiAutomation'), icon: AIIcon, disabled: true },
    { id: 'business', label: t('settings.dealership'), icon: BusinessIcon, disabled: false, path: '/settings/business' },
    */
  ];

  return (
    <MainLayout title={t('settings.subtitle')}>
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 4 } }}>
        <Stack spacing={3}>
          <ProfileSummaryCard name={userName} email={collaborator?.email} role={collaborator?.role} />

          <Card>
            <CardHeader
              title={t('settings.general')}
              subheader={t('settings.generalSubtitle')}
              titleTypographyProps={{ variant: 'h6' }}
            />
            <Divider />
            <List disablePadding>
              {menuItems.map((item, index) => (
                <ListItemButton
                  key={item.id}
                  disabled={item.disabled}
                  divider={index < menuItems.length - 1}
                  onClick={() => !item.disabled && item.path && navigate(item.path)}
                  sx={{ px: 3, py: 1.75 }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <item.icon sx={{ color: item.disabled ? 'text.disabled' : 'text.secondary' }} />
                  </ListItemIcon>
                  <ListItemText primary={item.label} secondary={item.hint} />
                  <ChevronRightIcon sx={{ color: 'action.disabled' }} />
                </ListItemButton>
              ))}
            </List>
          </Card>

          <Card>
            <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, '&:last-child': { pb: 2 } }}>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body1">{t('settings.signOut')}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {t('settings.signOutHint')}
                </Typography>
              </Box>
              <Button
                variant="outlined"
                color="error"
                startIcon={<LogoutIcon />}
                onClick={handleLogout}
                sx={{ flexShrink: 0 }}
              >
                {t('settings.signOutButton')}
              </Button>
            </CardContent>
          </Card>
        </Stack>
      </Container>
    </MainLayout>
  );
};

export default Settings;
